<template>
  <generic-modal :title="$t('account')" ref="generic_modal">
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("number") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.number" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('account type')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/account/type/catalog"
            name_field="name"
            value_field="type_id"
            @selected="type_changed"
            ref="type_dropdown"
          />
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "AccountModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.number || !v.meta.type_id /* || !v.meta.sale_price */;
    },
  },
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();
      get("/account", { uuid: uuid })
        .then((product) => {
          v.meta = product;
          if (v.meta.type_id) v.$refs.type_dropdown.set_value(v.meta.type_id);
        })
        .catch((error) => {
          console.log(error);
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/account", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/account", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        number: "",
        type_id: "",
        settings: {},
      };
      v.$refs.type_dropdown.clear();
      v.error = "";
      // v.uuid = "";
    },
    type_changed(type) {
      let v = this;
      if (type) v.meta.type_id = type.type_id;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
